import React from "react";
import Layout from "../components/layout";
import { sentryLog } from "@lululemon/dsp-shared/src/logger";
import { fetchServerProps } from "@lululemon/dsp-utils";

/**
 * @param {import("next/app").AppContext} param0
 */
const getLayoutInitialProps = async ({ ctx }) => {
  try {
    const serverProps = await fetchServerProps(ctx);

    return {
      serverProps
    };
  } catch (err) {
    sentryLog.error(
      "Failed to fetch initial props in with-layout stores page",
      {
        tags: {
          componentName: "with-layout",
          functionName: "getLayoutInitialProps"
        }
      }
    );
    return {
      serverProps: {}
    };
  }
};

const withLayout = (Component) => {
  const WithLayout = (props) => {
    return <Layout serverProps={props.serverProps}>{props.children}</Layout>;
  };

  WithLayout.getInitialProps = getLayoutInitialProps;

  Component.Layout = WithLayout;

  return Component;
};

export default withLayout;
